import React from 'react';
import './calendar.scss';

const Calendar = () => (
    <div className="innerContent">
        Kalender
    </div>
);

export default Calendar;